import { render, staticRenderFns } from "./onSubFormRowInsert-editor.vue?vue&type=template&id=0a3f755e&scoped=true&"
import script from "./onSubFormRowInsert-editor.vue?vue&type=script&lang=js&"
export * from "./onSubFormRowInsert-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f755e",
  null
  
)

export default component.exports